import { createMiddleware } from "@tanstack/react-start";

/** Header carrying the workspace (account owner) the user is currently acting in. */
export const ACTIVE_ACCOUNT_HEADER = "x-thiia-account";

/** Client side: sends the active workspace with every server function call. */
export const attachActiveAccount = createMiddleware({ type: "function" }).client(async ({ next }) => {
  let id: string | null = null;
  try {
    id = typeof window !== "undefined" ? window.localStorage.getItem("thiia.activeAccountId") : null;
  } catch {
    id = null;
  }
  return next({ headers: id ? { [ACTIVE_ACCOUNT_HEADER]: id } : {} });
});
